export default __webpack_public_path__ + "static/media/dashboard-black.1630da18.png";